import GroceryEditForm from "../components/GroceryEditForm";

function Edit() {
  return (
    <div className="rounded-lg items-center p-6 m-6 justify-center shadow-green-500/50 border shadow-md">
      <GroceryEditForm />
    </div>
  );
}

export default Edit;
